import { EmblaOptionsType } from 'embla-carousel-angular';

export const INITIAL_IMG_INDEX = 0;

export const CAROUSEL_OPTIONS: EmblaOptionsType = { loop: true };
export const CAROUSEL_THUMB_OPTIONS: EmblaOptionsType = { dragFree: true };
